import MultipleEndLayout from '@/layout/MultipleEndLayout.vue'
import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/task',
    name: 'Task',
    component: MultipleEndLayout,
    meta: {
      title: '任务'
    },
    children: [
      {
        path: 'center',
        name: 'taskCenter',
        component: () => import('@/views/task/taskCenter/index.vue'),
        meta: {
          navTitle: '任务中心',
          title: '任务中心',
          selfHeader: true,
          ignoreCache: true
        }
      },
      {
        path: 'mistake-exercise-list',
        name: 'mistakeExerciseList',
        component: () => import('@/views/task/mistakeExercise/list.vue'),
        meta: {
          navTitle: '错题练习',
          title: '错题练习',
          selfHeader: true,
          ignoreCache: true
        }
      },
      {
        path: 'sign-in-center',
        name: 'signInCenter',
        component: () => import('@/views/task/signInCenter/index.vue'),
        meta: {
          title: '签到中心',
          selfHeader: true,
          ignoreCache: true
        }
      },
      {
        path: 'mistake-exercise',
        name: 'mistakeExercise',
        component: () => import('@/views/task/mistakeExercise/index.vue'),
        meta: {
          navTitle: '错题练习',
          title: '错题练习'
        },
        beforeEnter: (to, from, next) => {
          const { gradeAnlzId, taskId, ...rest } = to.query
          to.query = {
            ...rest,
            taskId: gradeAnlzId || taskId
          }
          next()
        },
      },
      {
        path: 'group-task',
        name: 'groupTask',
        component: () => import('@/views/task/groupTask/index.vue'),
        meta: {
          navTitle: 'nav.taskDetails',
          title: '分组任务'
        }
      },
      {
        path: 'danmu-task',
        name: 'danmuTask',
        component: () => import('@/views/task/danmuTask/index.vue'),
        meta: {
          navTitle: 'nav.taskDetails',
          title: '课堂讨论'
        }
      },
      {
        path: '/questions',
        name: 'questions',
        component: () => import('@/views/questions/questions.vue'),
        meta: {
          navTitle: 'nav.taskDetails',
          title: '通用任务',
          ignoreCache: true
        },
      },
      {
        path: 'vote-survey',
        name: 'voteSurvey',
        component: () => import('@/views/questions/voteSurvey.vue'),
        meta: {
          navTitle: 'nav.taskDetails',
          title: '投票问卷',
        },
      },
      {
        path: '/questions_awser',
        name: 'questions_awser',
        component: () => import('@/views/questions/questions_awser.vue'),
        meta: {
          navTitle: 'nav.taskDetails',
          title: '出题练习',
          ignoreCache: true
        },
      },
      {
        path: '/error_questions',
        name: 'error_questions',
        redirect: '/task/mistake-exercise',
        meta: {
          title: '错题练习',
          ignoreCache: true
        }
      },
      {
        path: 'screen-quiz',
        name: 'screenQuiz',
        component: () => import('@/views/task/screenQuiz/index.vue'),
        meta: {
          title: '题目预览',
          ignoreCache: true
        }
      },
      {
        path: 'sign-in',
        name: 'signInTask',
        component: () => import('@/views/task/signIn/index.vue'),
        meta: {
          navTitle: 'nav.signInDetails',
          title: '签到任务',
          ignoreCache: true
        }
      },
      {
        path: 'sign-in/history-detail',
        name: 'signInHistoryDetail',
        component: () => import('@/views/task/signIn/history-detail.vue'),
        meta: {
          navTitle: 'nav.signInBreakdown',
          title: '签到明细'
        }
      },
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/task/notice/index.vue'),
        meta: {
          navTitle: '任务详情',
          title: '通知任务'
        }
      },
      {
        path: 'rush',
        redirect: to => ({ path: '/task/race-answer', query: { ...to.query, taskType: 'RUSH' } })
      },
      {
        path: 'call',
        redirect: to => ({ path: '/task/race-answer', query: { ...to.query, taskType: 'CALL' } })
      },
      {
        path: 'race-answer',
        name: 'raceAnswer',
        component: () => import('@/views/task/raceAnswer/index.vue'),
        meta: {
          navTitle: 'nav.taskDetails',
          title: '点答抢答',
          requiresAuth: true,
          ignoreCache: true
        }
      },
      {
        path: 'exam',
        name: 'examTask',
        component: () => import('@/views/task/test-task/index.vue'),
        meta: {
          navTitle: 'nav.taskDetails',
          title: '考试任务',
          ignoreCache: true,
        }
      }
    ]
  }
]


export default routes
